// extracted by mini-css-extract-plugin
module.exports = {"tabHeader":"styles-module__tabHeader___2LjDT","groupName":"styles-module__groupName___1bWJS","close":"styles-module__close___29qMr","tabs":"styles-module__tabs___3ZUhO"};